import { render, staticRenderFns } from "./LinkEdit.vue?vue&type=template&id=78019fa3"
import script from "./LinkEdit.vue?vue&type=script&lang=js"
export * from "./LinkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports